<template>
  <span
    v-if="disableTransitions"
    :class="classes"
    :style="{ backgroundColor: color, color: fontColor }"
    @click="handleClick"
  >
    <span :class="ns.e('content')">
      <slot />
    </span>
    <el-icon
      v-if="closable"
      :style="{ color: fontColor || '' }"
      :class="ns.e('close')"
      @click.stop="handleClose"
      @mouseenter="handleMouseEnter($event)"
      @mouseleave="handleMouseLeave($event)"
    >
      <Close />
    </el-icon>
  </span>
  <transition v-else :name="`${ns.namespace.value}-zoom-in-center`" appear>
    <span
      :class="classes"
      :style="{ backgroundColor: color, color: fontColor }"
      @click="handleClick"
    >
      <span :class="ns.e('content')">
        <slot />
      </span>
      <el-icon
        v-if="closable"
        :style="{ color: fontColor || '' }"
        :class="ns.e('close')"
        @click.stop="handleClose"
        @mouseenter="handleMouseEnter($event)"
        @mouseleave="handleMouseLeave($event)"
      >
        <Close />
      </el-icon>
    </span>
  </transition>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Close } from '@element-plus/icons-vue'
import ElIcon from '@park-ui/components/icon'

import { useNamespace, useSize } from '@park-ui/hooks'
import { tagEmits, tagProps } from './tag'

defineOptions({
  name: 'ElTag',
})
const props = defineProps(tagProps)
const emit = defineEmits(tagEmits)

const tagSize = useSize()
const ns = useNamespace('tag')
const classes = computed(() => {
  const { type, hit, effect, closable, round } = props
  return [
    ns.b(),
    ns.is('closable', closable),
    ns.m(type),
    ns.m(tagSize.value),
    ns.m(effect),
    ns.is('hit', hit),
    ns.is('round', round),
  ]
})

// methods
const handleClose = (event: MouseEvent) => {
  emit('close', event)
}

const handleClick = (event: MouseEvent) => {
  emit('click', event)
}

const handleMouseEnter = (event: MouseEvent) => {
  /** 如果当前props存在font-color，表示在自定义颜色 */
  if (props.fontColor) {
    ;(event.target as any).style.backgroundColor = props.fontColor
    ;(event.target as any).style.color = '#fff'
  }
}

const handleMouseLeave = (event: MouseEvent) => {
  /** 移出需要还原图标的颜色 */
  if (props.fontColor) {
    ;(event.target as any).style.backgroundColor = ''
    ;(event.target as any).style.color = props.fontColor
  }
}
</script>
